import {
  trapTabKey,
  whichTransitionEvent,
  getFocusableElementBySelector,
} from ".";

const NAV_ID = "main-nav";

export function mobileHideMainNav({ propertyName }: { propertyName: string }) {
  const transitionEvent = whichTransitionEvent();
  const mainNav = document.getElementById("main-nav");

  if (propertyName !== "transform") return;

  mainNav.classList.remove("active");
  mainNav.classList.remove("closing");

  // while (this.openSubNavElements.length > 0) {
  //   const { submenu } = this.whichSubNavLatest();
  //   submenu.removeEventListener(
  //     "keydown",
  //     this.mobileSubNavTrapTabKeyEvent,
  //     false
  //   );
  //   submenu.classList.remove("active");
  //   submenu.classList.remove("closing");
  //   this.openSubNavElements.pop();
  // }

  mainNav.removeEventListener(transitionEvent, mobileHideMainNav, false);
  mainNav.removeEventListener("keydown", mobileMainNavTrapTabs, false);
}

export function mobileShowMainNav({ propertyName }: { propertyName: string }) {
  const transitionEvent = whichTransitionEvent();
  const mainNav = document.getElementById("main-nav");

  if (propertyName !== "transform") return;
  getFocusableElementBySelector("main-nav", [
    "> div button",
    "> ul > li > a",
  ]).all[1].focus();
  mainNav.classList.add("active");
  mainNav.classList.remove("activating");
  mainNav.removeEventListener(transitionEvent, mobileShowMainNav, false);
  mainNav.addEventListener("keydown", mobileMainNavTrapTabs, false);
}

export function mobileMainNavTrapTabs(event: KeyboardEvent) {
  const focusableElement = getFocusableElementBySelector(NAV_ID, [
    "> div button",
    "> ul > li > a",
  ]);
  trapTabKey(event, focusableElement);
}

export function escapeClose(e) {
  if (e.key === "Escape") {
    // removes handleOutsideClick functionality from docs site
    if (this.nav.closest(".nsw_app_body")) return;

    const { link } = this.whichSubNavLatest();
    const isExpanded = link.getAttribute("aria-expanded") === "true";
    if (isExpanded) {
      this.toggleSubNavDesktop(true);
      e.preventDefault();
      link.focus();
    }
  }
}
